import {
  Product,
} from 'ui/mountainview';

export const MountainviewRoutes = {
  product: {
    component: Product,
    path: '/digital/klouterwoud/concert-video',
  },
}; 